import { ReactComponent as SdksIcon } from 'styles/icon/menu/sdks.svg';
import { ReactComponent as GuidesIcon } from 'styles/icon/menu/guides.svg';
import { ReactComponent as ApisIcon } from 'styles/icon/menu/apis.svg';

const NavigationIcon = ({ icon }) => {
  switch (icon) {
    case 'GuidesIcon':
    case 'Guides':
      return <GuidesIcon />;
    case 'SdksIcon':
    case "SDK'S":
      return <SdksIcon />;
    case 'ApisIcon':
    case "API'S":
      return <ApisIcon />;

    default:
      return null;
  }
};

export default NavigationIcon;
